import React from "react";
import PropTypes from "prop-types";

// Hooks
import useTranslate from "src/hooks/useTranslate";

// Components
import CustomField from "src/components/CustomField";
import IncidentTypeField from "src/components/Input/IncidentTypeField";

const WhatHappenedStep = ({ setFieldValue }) => {
  const getText = useTranslate();

  return (
    <>
      <IncidentTypeField
        label={getText("caseIncidentsPage.incidentTypeLabel")}
        name="incidentTypeId"
        setFieldValue={setFieldValue}
      />
      <CustomField
        label={getText("caseDetailPage.requiredIncidentDetails.descriptionTitle")}
        multiline
        name="description"
        placeholder={getText("caseIncidentsPage.descriptionPlaceholder")}
        type="text"
      />
    </>
  );
};

WhatHappenedStep.propTypes = {
  setFieldValue: PropTypes.func.isRequired
};

export default WhatHappenedStep;
